var next = __webpack_require__.x;
__webpack_require__.x = function() {
	return Promise.all([
		__webpack_require__.e(3492),
		__webpack_require__.e(560)
	]).then(next);
};